import useSWRImmutable from "swr/immutable";
import { relativeURL } from "../relativeURL";

const fetcher = (url) => fetch(url).then((res) => res.json());

export function useRetrieveDescription(pathwayInternalId) {
  const { data, error } = useSWRImmutable(
    () => relativeURL(`/api/description/${pathwayInternalId}`),
    fetcher
  );
  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
  };
}
